import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const aiSubscriptionPlanApi = createApi({
  reducerPath: 'AiSubscriptionPlans',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['aiPlans'],

  endpoints: (builder) => ({

    // ---------------------- GET ALL PLANS ----------------------
    getAllAiPlans: builder.query({
      query: ({ page = 1, keyword = '' }) => {
        let url = `admin/ai_plans?pageno=${page}`;
        if (keyword) url += `&search=${keyword}`;
        return { url, method: 'GET' };
      },
      transformResponse: (res) => res,
      providesTags: ['aiPlans'],
    }),

    // ---------------------- GET SINGLE PLAN BY ID ----------------------
    getSingleAiPlan: builder.query({
      query: (id) => ({
        url: `admin/ai_plans/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.body,
      providesTags: ['aiPlans'],
    }),

    // ---------------------- ADD NEW PLAN ----------------------
    addAiPlan: builder.mutation({
      query: (newPlanData) => ({
        url: 'admin/ai_plans',
        method: 'POST',
        body: newPlanData,
      }),
      invalidatesTags: ['aiPlans'],
    }),

    // ---------------------- UPDATE PLAN ----------------------
    updateAiPlan: builder.mutation({
      query: (data) => ({
        url: `admin/ai_plans/${data?.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['aiPlans'],
    }),

    // ---------------------- DELETE PLAN ----------------------
    deleteAiPlan: builder.mutation({
      query: (id) => ({
        url: `admin/ai_plans/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['aiPlans'],
    }),
  }),
});

export const {
  useGetAllAiPlansQuery,
  useGetSingleAiPlanQuery,
  useAddAiPlanMutation,
  useUpdateAiPlanMutation,
  useDeleteAiPlanMutation,
} = aiSubscriptionPlanApi;
